import { render } from "./inventorycategory.vue?vue&type=template&id=47b4016e"
import script from "./inventorycategory.vue?vue&type=script&lang=js"
export * from "./inventorycategory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__